import React from "react";
import { useTranslation } from "react-i18next";
import { FiTrash2, FiEdit } from "react-icons/fi";
import { RiImageAddFill } from "react-icons/ri";
import { FaArrowLeft } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa6";

import { Button, Col, Row } from "react-bootstrap";
import { DropZone } from "../index";
import { useAppContext } from "../../context";
import { useScreenSize } from "../../utils";
import style from "./Commands.module.css";

const ToolCommands = ({
  goToPrev,
  goToNext,
  handleDeleteImage,
  setEditCanvasModal,
}) => {
  const { state } = useAppContext();
  const screenSize = useScreenSize();
  const { t } = useTranslation();

  return (
    <Col
      xs={{ order: 0, span: 12 }}
      md={{ order: 0, span: 6 }}
      lg={{ order: 0, span: 6 }}
      className={`${style.toolCommandsCol} mt-4`}
    >
      <Row
        className={`p-0 m-0 justify-content-center justify-content-lg-start ${style.actionBtnRow}`}
      >
        <Col xs="auto" className={`p-0 ${style.actionBtnColumn}`}>
          <Button
            variant="dark"
            size="sm"
            className={style.toolCommandsActionBtn}
            disabled={
              state.images.length > 3 || state.images.length === 0
                ? true
                : false
            }
          >
            <RiImageAddFill size={16} /> <DropZone addDropdown={true} />
          </Button>
        </Col>
        {state.images.length > 1 && screenSize > 450 && (
          <Col xs="auto" className={`p-0 ${style.prevNextContainer}`}>
            <Button
              variant="dark"
              onClick={goToPrev}
              disabled={state.index === 0}
              size="sm"
              className={style.toolCommandsActionBtn}
            >
              <FaArrowLeft />
            </Button>

            <Button
              variant="dark"
              onClick={goToNext}
              disabled={state.images.length - 1 === state.index}
              size="sm"
              className={style.toolCommandsActionBtn}
            >
              <FaArrowRight />
            </Button>
          </Col>
        )}
        <Col xs="auto" className={`p-0 ${style.actionBtnColumn}`}>
          <Button
            variant="dark"
            size="sm"
            className={style.toolCommandsActionBtn}
            disabled={state.images.length > 0 ? false : true}
            onClick={() => setEditCanvasModal(true)}
          >
            <FiEdit /> {t("Edit")}
          </Button>
        </Col>
        <Col xs="auto" className={`p-0 ${style.actionBtnColumn}`}>
          <Button
            variant="dark"
            onClick={handleDeleteImage}
            size="sm"
            className={style.toolCommandsActionBtn}
            disabled={state.images.length > 0 ? false : true}
          >
            <FiTrash2 className="m-0" />
          </Button>
        </Col>
        {/* <Col xs="auto" className={`p-0 ${style.actionBtnColumn}`}>
          <div className={style.colorCircle} style={{backgroundColor: selectedColorContext}}></div>
        </Col> */}
        {/* <Col xs="auto" className={`p-0 ${style.actionBtnColumn}`}>
          <Button
            className={`${style.actionBtn} ${sortable && style.blackBtn}`}
            onClick={() => setSortable(!sortable)}
            variant="secondary"
            disabled={colormatch.length > 1 ? false : true}
          >
            {sortable ? null : <RiDragMove2Fill />}
            {sortable ? <span>{t("Done")}</span> : <span> {t("Reorder")}</span>}
          </Button>
        </Col> */}
      </Row>
    </Col>
  );
};

export default ToolCommands;
